export const faqData = [
  {
    question: '什么是51暗网？它与普通暗网有何区别？',
    answer: '51暗网是网络安全领域对特定暗网活动的统称。暗网（Dark Web）是互联网中需要通过特殊软件才能访问的加密网络层。51暗网话题之所以备受关注，是因为它涉及大量非法交易、数据泄露和网络犯罪活动。了解51暗网的运作机制，是保护自己免受其害的第一步。',
  },
  {
    question: '普通人会无意中访问到暗网吗？',
    answer: '正常情况下，普通用户使用标准浏览器（如Chrome、Edge、Safari）无法访问暗网。暗网需要使用Tor等特殊浏览器，并且需要知道具体的.onion域名地址才能访问。因此，只要你正常使用互联网，不会「不小心」进入暗网。但需要注意，部分钓鱼链接可能伪装成正常网站诱导用户点击。',
  },
  {
    question: '我的个人信息是否已经出现在暗网上？',
    answer: '重大数据泄露事件后，大量个人信息可能被贩卖至暗网。你可以通过专业的数据泄露查询服务检查自己的邮箱是否出现在已知的泄露数据库中。建议定期更换密码、开启双因素认证，即使信息已泄露，也能最大限度降低风险。',
  },
  {
    question: '使用VPN就能完全匿名访问暗网吗？',
    answer: 'VPN可以提供一定的隐私保护，但并不能保证完全匿名。不同的VPN服务商有不同的日志政策，部分免费VPN甚至可能记录和出售用户数据。真正的匿名访问需要结合Tor网络、安全的操作系统配置等多种手段。我们强烈不建议普通用户尝试访问暗网。',
  },
  {
    question: '暗网上的一切活动都是违法的吗？',
    answer: '并非暗网上所有活动都是违法的。暗网技术本身是中立的，一些记者、人权活动人士和举报人利用暗网的匿名特性来保护自己的安全。但不可否认，暗网上确实存在大量非法交易和犯罪活动。在中国，任何利用暗网从事违法犯罪活动的行为都将受到法律严惩。',
  },
  {
    question: '如何保护我的孩子不接触暗网有害信息？',
    answer: '保护青少年免受暗网有害信息影响，需要从多个层面入手：1）加强家庭网络素养教育，帮助孩子建立正确的网络安全意识；2）使用家长控制软件过滤不当内容；3）保持开放的沟通渠道，让孩子遇到问题愿意与家长交流；4）关注孩子的网络行为变化，及时发现异常。',
  },
  {
    question: '发现暗网上的违法信息应该怎么办？',
    answer: '如果你在网络上发现涉嫌违法的暗网相关信息，请不要自行尝试深入调查或接触。正确的做法是：1）保存相关页面截图或URL作为证据；2）通过中国互联网违法和不良信息举报中心（www.12377.cn）进行举报；3）或直接向当地公安机关网络安全部门报案。',
  },
  {
    question: '暗网交易使用的加密货币可以追踪吗？',
    answer: '虽然比特币等加密货币具有一定的匿名性，但并非完全不可追踪。区块链技术本身就是公开账本，所有交易记录都是公开可查的。执法机构可以通过区块链分析技术追踪资金流向。门罗币等隐私币虽然提供了更强的匿名性，但各国执法机构也在不断开发新的追踪技术。',
  },
];